import React from "react";
import style from "./LearningBottomNav.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { PiClipboardText, PiGraduationCap, PiListChecks } from "react-icons/pi";
import { VscGraph } from "react-icons/vsc";
import { useLearning } from "../Context/LearningContext";

const LearningBottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const { learningData } = useLearning();

    // Prioritize context data, fallback to safe defaults if context is empty (though it shouldn't be)
    const { assessmentExist } = learningData;

    const navItems = [
        {
            icon: <PiGraduationCap />,
            label: "Learn",
            active: currentPath === "/new/learnings/detail",
            onClick: () => {
                if (currentPath === "/new/learnings/detail") {
                    navigate("/new/learnings/detail");
                } else {
                    // With Context, we might not strictly need to pass state, 
                    // but passing it ensures the target page (NewLearningDetail) 
                    // can re-initialize if needed (though it prioritizes context now too).
                    // We'll keep passing it to be safe and consistent with previous behavior
                    // or we can rely fully on context.
                    // Let's rely on Context for data, but NewLearningDetail's useEffect checks location.state.
                    // So we must pass it.
                    navigate("/new/learnings/detail", {
                        state: {
                            singleTopic: learningData.singleTopic,
                            learning: learningData.learning,
                            mapped: learningData.mapped,
                            topicNo: learningData.topicNo,
                            mainID: learningData.mainID,
                            aiID: learningData.aiID,
                            roomID: learningData.roomID,
                            assessmentExist: learningData.assessmentExist,
                            assessmentInfo: learningData.assessmentInfo
                        }
                    });
                }
            }
        },
        {
            icon: <PiListChecks />,
            label: "Activity",
            active: currentPath === "/activity",
            onClick: () => navigate("/activity")
        },
        {
            icon: <PiClipboardText />,
            label: "Assessments",
            active: currentPath === "/assessments",
            onClick: () =>
                navigate("/assessments", {
                    state: {
                        singleTopic: learningData.singleTopic,
                        learning: learningData.learning,
                        mapped: learningData.mapped,
                        topicNo: learningData.topicNo,
                        mainID: learningData.mainID,
                        aiID: learningData.aiID,
                        roomID: learningData.roomID,
                        assessmentExist: learningData.assessmentExist,
                        assessmentInfo: learningData.assessmentInfo
                    }
                })
        },
        {
            icon: <VscGraph />,
            label: "Analytics",
            active: currentPath === "/insights",
            onClick: () => navigate("/insights")
        }
    ];

    return (
        <div className={style.bottomNav}>
            {navItems.map((item, index) => (
                <button
                    key={index}
                    className={`${style.navItem} ${item.active ? style.active : ""}`}
                    onClick={item.onClick}
                    disabled={item.disabled}
                >
                    <div className={style.icon}>{item.icon}</div>
                    {/* <span>{item.label}</span> */}
                </button>
            ))}
        </div>
    );
};

export default LearningBottomNav;
